import { Accordion } from "@app/shared/Accordion";
import { QESButton } from "@app/shared/qes-standards";
import { FC, useState } from "react";
import { PatternOfCareProviderLookup } from "./provider-lookup/PatternOfCareProviderLookup";
import { PatternOfCareAppendedProviders } from "./appended-providers/PatternOfCareAppendedProviders";
import { AppendedPatternOfCareProviderModel } from "./interfaces";

enum PatternOfCareViews {
  ProviderLookup,
  AppendedProviders,
}

interface PatternOfCareProps {
  exportEndpoint: string;
}

export const PatternOfCareProvidersPanel: FC<PatternOfCareProps> = (props: PatternOfCareProps) => {
  const [view, setView] = useState<PatternOfCareViews>(PatternOfCareViews.ProviderLookup);
  // used for the appended view, but need to be maintained externally
  const [loadingAppendedProviders, setLoadingAppendedProviders] = useState(false);
  const [appendedProviders, setAppendedProviders] = useState<AppendedPatternOfCareProviderModel[]>([]);

  const handleProviderLookupTabClick = () => {
    setView(PatternOfCareViews.ProviderLookup);
  }

  const handleAppendedProvidersTabClick = () => {
    setView(PatternOfCareViews.AppendedProviders);
  }

  return (
    <Accordion
      title="Pattern of Care Network Providers"
      testId="pattern-of-care-panel__accordion"
      lazyLoad={true}
    >
      <div id="pattern-of-care-accordion" className="tabs-style-2">
        <div className="d-flex justify-content-between align-items-center">
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <QESButton
                qesType="none"
                className={view === PatternOfCareViews.ProviderLookup ? "nav-link active" : "nav-link"}
                onClick={() => { handleProviderLookupTabClick() }}
                qesTestId="pattern-of-care-panel__provider-lookup-tab"
              >
                Provider Lookup
              </QESButton>
            </li>
            <li className="nav-item">
              <QESButton
                qesType="none"
                className={view === PatternOfCareViews.AppendedProviders ? "nav-link active" : "nav-link"}
                onClick={() => { handleAppendedProvidersTabClick() }}
                qesTestId="pattern-of-care-panel__appended-providers-tab"
              >
                Appended Providers
              </QESButton>
            </li>
          </ul>
        </div>

        {view === PatternOfCareViews.ProviderLookup && (<PatternOfCareProviderLookup />)}
        {view === PatternOfCareViews.AppendedProviders && (
          <PatternOfCareAppendedProviders
            exportEndpoint={props.exportEndpoint}
            loadingAppendedProviders={loadingAppendedProviders}
            setLoadingAppendedProviders={setLoadingAppendedProviders}
            providerDetails={appendedProviders}
            setProviderDetails={setAppendedProviders}
          />
        )}
      </div>
    </Accordion>
  );
}